import { useEffect, useState } from "react";
import { Video } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { VideoPlayer } from "@/lib/video";

export default function Videos() {
  useSeo(
    "From the Lot — Videos | Pit Stop Motors, Nampa Idaho",
    "Watch the latest videos from the Pit Stop Motors lot in Nampa, Idaho — new arrivals, walkarounds, and updates from Kendall."
  );
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    api.get("/lot-videos").then((r) => setVideos(r.data || [])).catch(() => setVideos([]));
  }, []);

  return (
    <div data-testid="videos-page">
      <section className="bg-primary grain">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-20 text-primary-foreground">
          <p className="overline !text-accent-bright">From the Lot</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight">Videos</h1>
          <p className="mt-3 text-primary-foreground/70 max-w-xl">
            New arrivals, walkarounds, and quick updates — straight from our lot in Nampa.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 md:px-10 py-14">
        {videos === null && <p className="text-muted-foreground">Loading…</p>}
        {videos && videos.length === 0 && (
          <div className="border border-dashed border-soft p-14 text-center text-muted-foreground" data-testid="videos-page-empty">
            <Video className="h-6 w-6 mx-auto opacity-40" />
            <p className="mt-3 font-serif text-2xl text-primary">No videos yet.</p>
            <p className="mt-1 text-sm">Check back soon — we post updates from the lot regularly.</p>
          </div>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {(videos || []).map((v) => (
            <div key={v.id} className="border border-soft bg-card" data-testid={`videos-page-item-${v.id}`}>
              <div className="aspect-video bg-black">
                <VideoPlayer url={v.video_url} title={v.title} testId={`videos-page-player-${v.id}`} />
              </div>
              <div className="p-5">
                <p className="font-serif text-xl text-primary">{v.title}</p>
                {v.caption && <p className="mt-1 text-sm text-muted-foreground">{v.caption}</p>}
                <p className="mt-2 text-xs text-muted-foreground">{new Date(v.created_at).toLocaleDateString()}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
